import * as React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { GOOGLE_RECAPTCHA_ENTERPRISE_PUBLIC_KEY } from '@/constants';

export const GoogleRecaptchaV3: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_RECAPTCHA_ENTERPRISE_PUBLIC_KEY} useEnterprise={true}>
    {children}
  </GoogleReCaptchaProvider>
);
